(() => {
  if (window.kmcPriceVisibilityInstalled) return;
  window.kmcPriceVisibilityInstalled = true;
  const selector = 'product-info[data-kmc-subscription-variant-ids]';
  const readyClass = 'kmc-subscription-price-ready';
  const initialized = new WeakSet();
  const isVisible = (element, root) => {
    if (!element.getClientRects().length) return false;
    for (let node = element; node && node !== root.parentElement; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (node.hidden || style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || style.opacity === '0') return false;
    }
    return true;
  };
  const setup = (root) => {
    if (initialized.has(root)) return;
    initialized.add(root);
    root.classList.remove(readyClass);
    const variants = new Set((root.dataset.kmcSubscriptionVariantIds || '').trim().split(/\s+/).filter(Boolean));
    if (!variants.size) return;
    let lastVariant = null;
    let waitingForApp = false;
    let queued = false;
    const currentVariant = () => root.querySelector('product-form input[name="id"]')?.value || root.querySelector('form[action*="/cart/add"] input[name="id"]')?.value || '';
    const sync = () => {
      queued = false;
      const variant = currentVariant();
      if (lastVariant !== null && variant !== lastVariant) waitingForApp = true;
      lastVariant = variant;
      const price = [...root.querySelectorAll('.appstle_sub_widget .appstle_sellingPlan_price:not(.appstle_onetime_amount_compare)')].find(element => /\d/.test(element.textContent || '') && isVisible(element, root));
      root.classList.toggle(readyClass, variants.has(variant) && !waitingForApp && Boolean(price));
    };
    const schedule = () => {
      if (!queued) { queued = true; requestAnimationFrame(sync); }
    };
    const invalidate = (event) => {
      if (event.target.closest?.('variant-selects') || event.target.matches?.('input[name="id"]')) {
        waitingForApp = true;
        root.classList.remove(readyClass);
      }
      schedule();
    };
    root.addEventListener('change', invalidate);
    const observer = new MutationObserver(records => {
      const variant = currentVariant();
      if (variant !== lastVariant) { waitingForApp = true; lastVariant = variant; root.classList.remove(readyClass); }
      const appChanged = records.some(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        return (record.type !== 'attributes' && Boolean(target?.closest('.appstle_sub_widget'))) || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('.appstle_sub_widget') || node.querySelector('.appstle_sub_widget')));
      });
      if (appChanged) waitingForApp = false;
      schedule();
    });
    observer.observe(root, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'value', 'checked']});
    window.addEventListener('resize', schedule, {passive: true});
    schedule();
  };
  const scan = () => document.querySelectorAll(selector).forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once: true});
  else scan();
  document.addEventListener('shopify:section:load', scan);
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) scan();
  }).observe(document.documentElement, {childList: true, subtree: true});
})();
